__turbopack_context__.v({
  "h1": "hx-module__uk-Nya__h1",
  "h2": "hx-module__uk-Nya__h2",
  "h3": "hx-module__uk-Nya__h3",
  "h4": "hx-module__uk-Nya__h4",
  "h5": "hx-module__uk-Nya__h5",
  "inherit": "hx-module__uk-Nya__inherit",
});
